/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetSafetyAppendixResponse } from '../models/get-safety-appendix-response';
import { GetFormRequest } from '../models/get-form-request';
import { CreateSafetyAppendixRequest } from '../models/create-safety-appendix-request';
@Injectable({
  providedIn: 'root',
})
class SafetyAppendixService extends __BaseService {
  static readonly SafetyAppendixGetAllPath = '/SafetyAppendix/GetAll';
  static readonly SafetyAppendixGetByIdPath = '/SafetyAppendix/GetById';
  static readonly SafetyAppendixCreatePath = '/SafetyAppendix/Create';
  static readonly SafetyAppendixUploadFilePath = '/SafetyAppendix/UploadFile';
  static readonly SafetyAppendixDeletePath = '/SafetyAppendix/Delete';
  static readonly SafetyAppendixDeleteRangePath = '/SafetyAppendix/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  SafetyAppendixGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetSafetyAppendixResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/SafetyAppendix/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetSafetyAppendixResponse>>;
      })
    );
  }  SafetyAppendixGetAll(): __Observable<Array<GetSafetyAppendixResponse>> {
    return this.SafetyAppendixGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetSafetyAppendixResponse>)
    );
  }

  /**
   * @param request undefined
   */
  SafetyAppendixGetByIdResponse(request: GetFormRequest): __Observable<__StrictHttpResponse<GetSafetyAppendixResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyAppendix/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetSafetyAppendixResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyAppendixGetById(request: GetFormRequest): __Observable<GetSafetyAppendixResponse> {
    return this.SafetyAppendixGetByIdResponse(request).pipe(
      __map(_r => _r.body as GetSafetyAppendixResponse)
    );
  }

  /**
   * @param request undefined
   */
  SafetyAppendixCreateResponse(request: CreateSafetyAppendixRequest): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyAppendix/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyAppendixCreate(request: CreateSafetyAppendixRequest): __Observable<string> {
    return this.SafetyAppendixCreateResponse(request).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param params The `SafetyAppendixService.SafetyAppendixUploadFileParams` containing the following parameters:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  SafetyAppendixUploadFileResponse(params: SafetyAppendixService.SafetyAppendixUploadFileParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.FormId != null) { __formData.append('FormId', params.FormId as string | Blob);}
    if (params.File != null) { __formData.append('File', params.File as string | Blob);}
    if (params.DirectoryPath != null) { __formData.append('DirectoryPath', params.DirectoryPath as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyAppendix/UploadFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SafetyAppendixService.SafetyAppendixUploadFileParams` containing the following parameters:
   *
   * - `FormId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  SafetyAppendixUploadFile(params: SafetyAppendixService.SafetyAppendixUploadFileParams): __Observable<Blob> {
    return this.SafetyAppendixUploadFileResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  SafetyAppendixDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyAppendix/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  SafetyAppendixDelete(id?: string): __Observable<Blob> {
    return this.SafetyAppendixDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  SafetyAppendixDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyAppendix/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  SafetyAppendixDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.SafetyAppendixDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module SafetyAppendixService {

  /**
   * Parameters for SafetyAppendixUploadFile
   */
  export interface SafetyAppendixUploadFileParams {
    FormId?: string;
    File?: null | Blob;
    DirectoryPath?: null | string;
  }
}

export { SafetyAppendixService }
